import * as Yup from 'yup';

export const CompaignManagementValidators = Yup.object().shape({
  name: Yup.string().required('* Campo obrigatório'),
});
